export default __webpack_public_path__ + "static/media/banner.fe8806b3.png";